module.exports = __webpack_public_path__ + "img/error.b7229589.svg";